/** User-facing strings: the operator panel (/dashboard/admin, #157). */
export const admin = {
    nav: {
        label: "Sterfive admin",
        organisations: "Organisations",
        hostedGds: "Hosted GDS",
        audit: "Audit log",
    },
    page: {
        title: "Admin",
        description:
            "Sterfive operators only. Every change asks for a reason, is kept in the audit log and is notified to the organisation's owners.",
    },
    create: {
        heading: "Create organisation",
        intro: "The owner must have signed in once. Names are unique, compared without case and extra spaces.",
        name: "Name",
        owner: "Owner's sign-in email",
        submit: "Create...",
    },
    duplicates: {
        heading: "Duplicate names",
        intro: "Organisations created before names were unique. Rename all but one; nothing is changed automatically.",
        group: '"{name}"',
        caption: "Organisations named {name}",
    },
    organisations: {
        heading: "Organisations",
        caption: "Organisations",
        showPersonal: "Show personal organisations ({count})",
        hidePersonal: "Hide personal organisations",
        none: "No organisation yet.",
        nameAndSlug: "Name and slug",
        owners: "Owners",
        members: "Members",
        agents: "Agents",
        gds: "GDS",
        actions: "Actions",
        personal: " (personal)",
        created: "Created",
        noneValue: "none",
        service: "{slug} ({state})",
        membersButton: "Members",
        membersOf: "Members of {name} ({slug})",
        rename: "Rename",
        renameOf: "Rename {name} ({slug})",
        delete: "Delete",
        deleteOf: "Delete {name} ({slug})",
        deleteBlockedPersonal: "A personal organisation cannot be deleted.",
        deleteBlocked: "Cannot be deleted while it has {what}.",
        attached: {
            agents: "{count, plural, one {# agent} other {# agents}}",
            relayedServers: "{count, plural, one {# relayed server} other {# relayed servers}}",
            importBindings: "{count, plural, one {# import binding} other {# import bindings}}",
            managedServices: "{count, plural, one {# hosted service} other {# hosted services}}",
        },
    },
    members: {
        heading: "Members of {name} ({slug})",
        close: "Close",
        email: "Email",
        role: "Role",
        actions: "Actions",
        roleOf: "Role of {name}",
        apply: "Apply",
        remove: "Remove",
        removeOf: "Remove {name}",
        addHeading: "Add a user to {name} ({slug})",
        addEmail: "Sign-in email",
        addRole: "Role",
        addSubmit: "Add user...",
    },
    audit: {
        heading: "Audit log",
        empty: "No operator action yet.",
        range: "{from} to {to} of {total}, newest first",
        caption: "Operator actions, newest first",
        time: "Time",
        operator: "Operator",
        action: "Action",
        reason: "Reason",
        pages: "Audit log pages",
        newer: "Newer entries",
        older: "Older entries",
        target: "{org}, {target}",
        actions: {
            organisationCreate: "Created organisation",
            organisationRename: "Renamed organisation",
            organisationDelete: "Deleted organisation",
            memberAdd: "Added member",
            memberRole: "Changed role",
            memberRemove: "Removed member",
        },
        change: {
            both: "{key}: {before} → {after}",
            after: "{key}: {after}",
            before: "{key} was {before}",
        },
    },
    dialog: {
        createTitle: "Create organisation {name}?",
        createText: "{owner} becomes its owner. You are not made a member.",
        createConfirm: "Create organisation",
        renameTitle: "Rename {name} ({slug})?",
        renameText: "The slug, the members and the agents stay. The owners are notified.",
        renameConfirm: "Rename",
        deleteTitle: "Delete {name} ({slug})?",
        deleteText:
            "The organisation, its slug and its name are removed, and the name can be used again. {members, plural, one {Its # member loses} other {Its # members lose}} access and {members, plural, one {is} other {are}} notified. This cannot be undone.",
        deleteConfirm: "Delete organisation",
        addTitle: "Add {email} to {name}?",
        addText: "They join as {role}, even if they already belong to another organisation.",
        addConfirm: "Add member",
        roleTitle: "Make {who} {role} of {name}?",
        roleText: "Their role changes from {from} to {to}.",
        roleConfirm: "Change role",
        removeTitle: "Remove {who} from {name}?",
        removeText: "They lose access to the organisation's agents at once. The last owner cannot be removed.",
        removeConfirm: "Remove member",
        newName: "New name",
        reason: "Reason (required)",
        reasonHint:
            "A ticket number or a short explanation, at least 5 characters. It is kept in the audit log and shown to the organisation's owners.",
        reasonTooShort: "Give a reason of at least {min} characters (a ticket number, for example).",
        reasonTooLong: "At most {max} characters.",
        cancel: "Cancel",
        saving: "Saving...",
        done: "{action}: done. The audit log has the entry.",
    },
};
